import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

import { ListToMap } from '../../../../lib/lib-ngx/utils/ListToMap';
import { ApiLavandierService } from '../../../../lib/lib-ngx/web-services/api-lavandier.service';

@Component({
  selector: 'lm-new-lavandier',
  templateUrl: './new-lavandier.component.html',
  styleUrls: ['./new-lavandier.component.scss']
})
export class NewLavandierComponent implements OnInit {
  public newLavandierForm: FormGroup;
  public lavandierMap = new Map();
  public userDetails = null;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private apiLavandierService: ApiLavandierService,
  ) {
  }

  ngOnInit() {
    this.buildForm();
    this.loadLavandierMap();

    this.search = this.search.bind(this);
    this.formatter = this.formatter.bind(this);
  }

  buildForm() {
    this.newLavandierForm = this.fb.group({
      existingUser: this.fb.group({
        admin: [false],
        internalAdmin: [false],
      }),
    });
  }

  loadLavandierMap() {
    this.apiLavandierService.getLavandiers()
      .pipe(map(lavandierList => ListToMap.list(lavandierList.rows, 'userId')))
      .subscribe(
        (lavandierMap: Map<number, Object>) => this.lavandierMap = lavandierMap
      );
  }

  search(text: Observable<any>): Observable<any> {
    return text.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(inputData => {
        this.userDetails = null;
        if (inputData !== '') {
          let obs = this.apiLavandierService.getUserList({name: inputData});
          if (!isNaN(inputData)) {
            obs = this.apiLavandierService.getUserList({id: inputData});
          }
          return obs.pipe(map((data: any) => data.rows.filter(user => !this.lavandierMap.has(user.id))));
        } else {
          return of([]);
        }
      })
    );
  }

  formatter(user: any) {
    return new TitleCasePipe().transform(user.id + ' ' + user.lastName + ' ' + user.firstName);
  }

  selectUser(user) {
    this.userDetails = null;
    if (!this.lavandierMap.has(user.id)) {
      this.userDetails = user;
    }
  }

  /**
   * Method called to add a new lavandier
   * @param lavandierForm Must be newLavandierForm.controls['existingUser'] or newLavandierForm.controls['newUser']
   */
  onNewLavandier(lavandierForm) {
    this.apiLavandierService.postLavandier({
      userId: this.userDetails.id,
      admin: this.newLavandierForm.controls.existingUser.value.admin,
      internalAdmin: this.newLavandierForm.controls.existingUser.value.internalAdmin,
    })
      .subscribe(lavandier => this.router.navigate(['/lavandier/details', lavandier.id]));
  }
}
